import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/valeur/valeur1.png")